import { z } from "zod";
import type { infer as zInfer } from "zod/lib/types";

export const bettingEventStatus = z.object({
  awayScore: z.number(),
  homeScore: z.number(),
  eventType: z.string(),
  name: z.string(),
  periodScores: z.record(
    z.string(),
    z.object({
      awayScore: z.number(),
      homeScore: z.number(),
      number: z.number(),
      name: z.string().nullish(),
    }),
  ),
  scheduledStartTime: z.string(),
});

export type BettingEventStatus = zInfer<typeof bettingEventStatus>;
